import { compose, constant, eq, join, reject, trim, map } from 'lodash/fp';
import { UnicodeEntity } from '@mews/enums';
import { when, whenIsEmpty } from '@mews/fp';
import { isSizeOne, appendEmptyString } from '@mews-commander/utils';
import { Multipliers } from '../../transformProductOrders/types';

export const joinCostParts = join(` ${UnicodeEntity.MultiplicationSign} `);

export const filterMultipliers = ({ night, unit, person }: Multipliers) => reject(eq(1), [unit, person, night]);

export const formatOrderItemMultipliers = compose(
    trim,
    joinCostParts,
    when(isSizeOne, appendEmptyString),
    whenIsEmpty<[string[]], string[]>(constant(['1'])),
    map(String),
    filterMultipliers
);
